import { fetchDashboardDataApi } from '../api/dashboardApi';
import {requestStarted,requestCompleted} from "./common"


export const setDashboard =(data) => {
  return {
    type : "SET_DASHBOARD",
    data
  }
}
 
export const setDashboardFail =(data) => {
    return {
      type : "FAIL_DASHBOARD",
      data
    }
  }



export const fetchDashboardData=(token) =>{
  return dispatch =>{
      dispatch(requestStarted());
      fetchDashboardDataApi(token).then((result) => {
       dispatch(requestCompleted());
       if(result.success){
        dispatch(setDashboard(result));
      }
      else {
        dispatch(setDashboardFail(result));
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/actions/dashboard.js